export default {
  BIOMETHANE: 'BIOMETHANE',
  HYDROGEN: 'HYDROGEN',
  RENEWABLE_ELECTRICITY: 'RENEWABLE_ELECTRICITY',
  RENEWABLE_ENERGY: 'RENEWABLE_ENERGY',
  KHG: 'KHG',
};
